import '../styles/viewer.css'
import React, { useState, useEffect, useMemo, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Row, Col, Form, Spinner, OverlayTrigger, Button, Tooltip } from 'react-bootstrap'
import * as XLSX from 'xlsx';
import Chart from 'react-apexcharts';
import Select from 'react-select'
import ChartTypeModal from '../components/ChartTypeModal'
import Message from '../components/Message'
import AddFolderModal from '../components/AddFolderModal'
import AddLabelModal from "../components/AddLabelModal"
import LoginModal from "../components/LoginModal"
import RegisterModal from "../components/RegisterModal"
import ForgotModal from "../components/ForgotModal"

import {
    getFolders,
} from '../actions/platformActions'

import {
    getData,
    updateSeries,
    getCountries,
    getUnits,
    getCountryData,
} from '../actions/viewerActions'
import { roundy } from '../components/Utilities';
import { SAVE_SERIES_RESET, UPDATE_SERIES_RESET, } from '../constants/viewerConstants'

function ViewerModal({ meta, closeCallback, isSaved = null }) {
    // isSaved = {id: idSerie, folder: idFolder}

    const dispatch = useDispatch()
    const [menuOption, setMenuOption] = useState('settings');

    const [addFolderModal, setAddFolderModal] = useState(false)

    const [addLabelModal, setAddLabelModal] = useState(false)
    const [labelId, setLabelId] = useState(null)

    const [metaSender, setMetaSender] = useState(meta)

    const [chartModal, setChartModal] = useState(false)
    const [chartType, setChartType] = useState(null)
    const [chartId, setChartId] = useState(null)

    // const [unitValue, setUnitValue] = useState({value: meta.units[0], label: meta.units[0]})
    const [nameDisabled, setNameDisabled] = useState((isSaved ? true : false))
    const [nameValue, setNameValue] = useState((isSaved ? isSaved.name : null))
    const [unitValue, setUnitValue] = useState(meta.chart.unit)
    const [government, setGovernment] = useState(null)

    const [sourceValue, setSourceValue] = useState('')
    // const [frequencyValue, setFrequencyValue] = useState({value: meta.frequency, label: meta.frequency})
    const [frequencyValue, setFrequencyValue] = useState(meta.chart.frequency)
    const [countryValue, setCountryValue] = useState([])
    // const [countryValue, setCountryValue] = useState(meta.chart.country)
    const [countryList, setCountryList] = useState(null)
    const [regionList, setRegionList] = useState(['LAC', 'Central_america', 'Southern_cone', 'Caribbean', 'Andean'])
    const [unitList, setUnitList] = useState(null)
    const [frequencyList, setFrequencyList] = useState(null)
    // const [legendValue, setLegendValue] = useState(true)
    const [legendValue, setLegendValue] = useState(meta.chart.legend)

    // Estado para transformaciones
    const [transformationValue, setTransformationValue] = useState(
        meta.chart?.transformation || { value: '', label: 'No transformation' }
    )
    const [availableTransformations, setAvailableTransformations] = useState([])

    // Diccionario de transformaciones
    const transformationLabels = {
        'MoM %': 'month-on-month change – %',
        'QoQ %': 'quarter-on-quarter change – %',
        'YoY %': 'year-on-year change – %',
        'MA3': '3-month moving average',
        'MA6': '6-month moving average',
        'MA12': '12-month moving average',
        '': 'No transformation',
        null: 'No transformation'
    }

    const [definitionValue, setDefinitonValue] = useState(meta.units_definitions[meta.units[0]])
    // const [xAnnotationValue, setXannotationValue] = useState([{id: 0, value: '', label: ''}])
    const [xAnnotationValue, setXannotationValue] = useState(meta.chart.xaxis)
    const [xAnnotationChart, setXannotationChart] = useState([])
    // const [yAnnotationValue, setYannotationValue] = useState([{id: 0, value: '', label: ''}])
    const [yAnnotationValue, setYannotationValue] = useState(meta.chart.yaxis)
    const [yAnnotationChart, setYannotationChart] = useState([])
    // const [metricValue, setMetricValue] = useState([{id: 0, value: '', label: ''}])
    const [metricValue, setMetricValue] = useState(meta.chart.metrics)
    // const [highlightValue, setHighlightValue] = useState([{
    //     id: 0,
    //     x1: {value: '', label: ''},
    //     x2: {value: '', label: ''},
    // }])
    const [highlightValue, setHighlightValue] = useState(meta.chart.highlight)

    const defaultColors = useMemo(() => meta.chart?.colors || [
        '#0073CF',
        '#7209B7',
        '#D62828',
        '#06A77D',
        '#F5A623',
        '#00B4D8',
        '#164773',
        '#3B8C6E',
        '#D94F04',
        '#42515C',
        '#89D99D',
        '#323050',
    ], [meta.chart?.colors]);

    const [loginModal, setLoginModal] = useState(false)
    const [registerModal, setRegisterModal] = useState(false)
    const [forgotModal, setForgotModal] = useState(false)


    const userLogin = useSelector(state => state.userLogin)
    const { loading: loadingUser, error: errorUser, userInfo } = userLogin
    // const [yAnnotationChart, setYannotationChart] = useState([])

    const [xdata, setXdata] = useState([])
    const [ydata, setYdata] = useState([])

    const [table, setTable] = useState([])
    const [yearRange, setYearRange] = useState('max')
    const [fromYear, setFromYear] = useState('')
    const [toYear, setToYear] = useState('')

    const [specificData, setSpecificData] = useState({
        Countries: {},
        Regions: {}
    })

    // Estado para controlar la carga automática del primer país
    const [autoLoadingFirstCountry, setAutoLoadingFirstCountry] = useState(false)
    const initialLoadRef = useRef(false)

    useEffect(() => {
        dispatch({
            type: UPDATE_SERIES_RESET,
        })
        const area = meta.area
        const topic = meta.topic
        const indicator = meta.indicator
        dispatch(getCountries(indicator))
        dispatch(getUnits(indicator))
        // dispatch(getData(area, topic, indicator))
        dispatch(getFolders())
    }, [dispatch, meta.area, meta.indicator, meta.topic])

    const dataInfo = useSelector(state => state.dataList)
    const { loading, error, data } = dataInfo

    // useEffect(() => {
    //     if(data){
    //         console.log("DATA: ", data)
    //     }
    // }, [data])




    // useEffect(() => {
    //     if (data != undefined) {
    //         let countries = Object.keys(data.data_dict.Countries)
    //         let regions = Object.keys(data.data_dict.Regions)

    //         let userCountries = meta.chart.country.map(item => item.value)

    //         // console.log("****meta: ", meta)

    //         if (meta.chart.country.length == 0) {
    //             const item = countries[0]
    //             setCountryValue([
    //                 {
    //                     id: 0,
    //                     value: item,
    //                     label: item,
    //                     color: defaultColors[0],
    //                     type: 'line',
    //                     countryType: 'country'
    //                 }
    //             ])
    //             // setCountryValue([
    //             //     {
    //             //         id: 0,
    //             //         value: '',
    //             //         label: '',
    //             //         color: defaultColors[0],
    //             //         type: '',
    //             //         countryType: ''
    //             //     }
    //             // ])
    //         } else {
    //             setCountryValue(meta.chart.country.map((item, index) => {
    //                 return {
    //                     id: index,
    //                     value: item.value,
    //                     label: item.label,
    //                     color: item.color,
    //                     type: item.type,
    //                     countryType: item.countryType
    //                 }
    //             }))
    //         }

    //         // if(userCountries.length == 0){

    //         //     setCountryValue([
    //         //         {
    //         //             id: 0,
    //         //             value: countries[0],
    //         //             label: countries[0],
    //         //             color: defaultColors[0],
    //         //             type: 'line',
    //         //             countryType: 'country'
    //         //         }
    //         //     ])
    //         // }else{

    //         //     let finalCountry = [...countries, ...regions].filter(item => userCountries.includes(item))


    //         //     setCountryValue(finalCountry.map((item, index) => {
    //         //             return {
    //         //                 id: index,
    //         //                 value: item,
    //         //                 label: item,
    //         //                 color: defaultColors[index],
    //         //                 type: 'line',
    //         //                 countryType: (countries.includes(item)) ? 'country':
    //         //                             (regions.includes(item)) ? 'region': ''
    //         //             }
    //         //         }
    //         //         )
    //         //     )
    //         // }
    //         // setCountryList(countries)
    //         setRegionList(regions)
    //     }
    // }, [data])

    // useEffect(() => {
    //     console.log("countryValue changed")
    //     if(tempData){
    //         console.log("*******: ", tempData)
    //     }

    //     // dispatch(getCountryData())
    // }, [countryValue])

    const countriesInfo = useSelector(state => state.getCountries)
    const { loading: loadingCountries, countries: finalCountries, error: errorCountries } = countriesInfo

    useEffect(() => {
        if (finalCountries && finalCountries.data_dict && !initialLoadRef.current) {
            let tempCountries = finalCountries.data_dict.countries
            
            // Validar que tempCountries sea un array válido
            if (!tempCountries || !Array.isArray(tempCountries)) {
                console.log('No se encontraron países válidos para este indicador')
                return
            }
            
            setCountryList(tempCountries)

            // Si hay países preseleccionados desde SearchCard
            if (meta.chart.country.length > 0 && countryValue.length === 0) {
                setAutoLoadingFirstCountry(true)
                
                // Filtrar solo los países que existen en la lista de países disponibles para este indicador
                const validCountries = meta.chart.country.filter(country => 
                    tempCountries.includes(country.value)
                )

                if (validCountries.length > 0) {
                    // Configurar los países válidos
                    setCountryValue(validCountries.map((item, index) => ({
                        id: index,
                        value: item.value,
                        label: item.label,
                        color: item.color || defaultColors[index % defaultColors.length],
                        type: item.type || 'line',
                        countryType: item.countryType || 'country'
                    })))

                    // Hacer peticiones para obtener los datos de cada país válido
                    const indicator = meta.indicator
                    validCountries.forEach(country => {
                        dispatch(getCountryData(indicator, country.value))
                    })
                } else if (tempCountries.length > 0) {
                    // Si ningún país preseleccionado es válido, cargar el primero disponible
                    const sortedCountries = [...tempCountries].sort((a, b) => a.localeCompare(b))
                    const firstCountry = sortedCountries[0]

                    const defaultCountry = [{
                        id: 0,
                        value: firstCountry,
                        label: firstCountry,
                        color: defaultColors[0],
                        type: 'line',
                        countryType: 'country'
                    }]

                    setCountryValue(defaultCountry)
                    const indicator = meta.indicator
                    dispatch(getCountryData(indicator, firstCountry))
                }
                
                initialLoadRef.current = true
            } 
            // Si no hay países seleccionados y hay países disponibles, cargar el primero automáticamente
            else if (meta.chart.country.length === 0 && tempCountries && tempCountries.length > 0) {
                setAutoLoadingFirstCountry(true)

                // Ordenar países alfabéticamente y tomar el primero
                const sortedCountries = [...tempCountries].sort((a, b) => a.localeCompare(b))
                const firstCountry = sortedCountries[0]

                // Configurar el primer país
                const defaultCountry = [{
                    id: 0,
                    value: firstCountry,
                    label: firstCountry,
                    color: defaultColors[0],
                    type: 'line',
                    countryType: 'country'
                }]

                setCountryValue(defaultCountry)

                // Hacer petición para obtener los datos del primer país
                const indicator = meta.indicator
                dispatch(getCountryData(indicator, firstCountry))
                
                // Marcar que ya se hizo la carga inicial
                initialLoadRef.current = true
            }
        }
    }, [countryValue.length, defaultColors, dispatch, finalCountries, meta.chart.country, meta.indicator])

    const unitsInfo = useSelector(state => state.getUnits)
    const { loading: loadingUnits, units: finalUnits, error: errorUnits } = unitsInfo

    useEffect(() => {

        if (finalUnits && finalUnits.data_dict) {
            setFrequencyList(finalUnits.data_dict.frequencies_available)
            setUnitList(finalUnits.data_dict.frequency_summary)

        }
    }, [finalUnits])

    const unitOptions = unitList?.[`${frequencyValue.label}`]?.units?.map(item => ({
        value: item, label: item.charAt(0).toUpperCase() + item.slice(1)
    })) || []

    // Efecto para verificar si la unidad actual está disponible cuando cambia la frecuencia
    useEffect(() => {
        if (unitList && frequencyValue && frequencyValue.label) {
            const availableUnits = unitList[frequencyValue.label]?.units || []
            
            // Verificar si la unidad actual está disponible para la nueva frecuencia
            const currentUnitValue = unitValue?.value
            if (currentUnitValue) {
                const currentUnitExists = availableUnits.includes(currentUnitValue)
                
                if (!currentUnitExists && availableUnits.length > 0) {
                    // La unidad actual no existe para esta frecuencia, seleccionar la primera disponible
                    const firstAvailableUnit = availableUnits[0]
                    console.log(`⚠️ Unidad "${currentUnitValue}" no disponible para frecuencia "${frequencyValue.label}". Cambiando a "${firstAvailableUnit}"`)
                    setUnitValue({ 
                        value: firstAvailableUnit, 
                        label: firstAvailableUnit.charAt(0).toUpperCase() + firstAvailableUnit.slice(1) 
                    })
                }
            } else if (availableUnits.length > 0) {
                // No hay unidad seleccionada, seleccionar la primera disponible
                const firstAvailableUnit = availableUnits[0]
                setUnitValue({ 
                    value: firstAvailableUnit, 
                    label: firstAvailableUnit.charAt(0).toUpperCase() + firstAvailableUnit.slice(1) 
                })
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [frequencyValue, unitList])

    // Efecto para extraer transformaciones disponibles de los datos cargados
    useEffect(() => {
        if (specificData && frequencyValue?.value && unitValue?.value) {
            const transformationsSet = new Set()
            
            // Extraer transformaciones de los datos de países
            Object.values(specificData.Countries || {}).forEach(countryData => {
                if (countryData?.data) {
                    countryData.data.forEach(record => {
                        if (record.frequency === frequencyValue.value && record.unit === unitValue.value) {
                            const trans = record.transformation
                            if (trans && String(trans).trim()) {
                                transformationsSet.add(String(trans).trim())
                            } else {
                                transformationsSet.add('') // Para "No transformation"
                            }
                        }
                    })
                }
            })
            
            // Extraer transformaciones de los datos de regiones
            Object.values(specificData.Regions || {}).forEach(regionData => {
                if (regionData?.data) {
                    regionData.data.forEach(record => {
                        if (record.frequency === frequencyValue.value && record.unit === unitValue.value) {
                            const trans = record.transformation
                            if (trans && String(trans).trim()) {
                                transformationsSet.add(String(trans).trim())
                            } else {
                                transformationsSet.add('')
                            }
                        }
                    })
                }
            })
            
            const transformationsList = Array.from(transformationsSet).sort()
            setAvailableTransformations(transformationsList)
            
            // Verificar si la transformación actual está disponible
            const currentTransValue = transformationValue?.value || ''
            if (!transformationsList.includes(currentTransValue)) {
                // La transformación actual no está disponible, seleccionar la primera
                if (transformationsList.length > 0) {
                    const firstTrans = transformationsList[0]
                    console.log(`⚠️ Transformación "${currentTransValue}" no disponible. Cambiando a "${firstTrans || 'No transformation'}"`)
                    setTransformationValue({
                        value: firstTrans,
                        label: transformationLabels[firstTrans] || firstTrans || 'No transformation'
                    })
                }
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [specificData, frequencyValue, unitValue])

    // Opciones para el selector de transformaciones
    const transformationOptions = availableTransformations.map(trans => ({
        value: trans,
        label: transformationLabels[trans] || trans || 'No transformation'
    }))

    useEffect(() => {
        setDefinitonValue(meta.units_definitions[unitValue.value])
    }, [meta.units_definitions, unitValue])

    // const countryOptions = countryList?.map(item => {
    //     return {value: item, label: item}
    // })

    const countryOptions = [
        {
            label: 'Countries',
            options: countryList?.sort((a, b) => a.localeCompare(b)).map(item => {
                return { value: item, label: item, type: 'country' }
            }) || []
        },
        {
            label: 'Regions',
            options: regionList?.sort((a, b) => a.localeCompare(b)).map(item => {
                return { value: item, label: item, type: 'region' }
            }) || []
        }
    ]
    const xAnnotationsOptions = xdata?.map(item => {
        return { value: item, label: item }
    })
    const yAnnotationsOptions = ydata?.map(item => {
        return { value: item, label: item }
    })

    const metricOptions = [
        { value: 'mean', label: 'Mean' },
        { value: 'median', label: 'Median' },
        { value: 'p10', label: 'Percentile 10' },
        { value: 'p20', label: 'Percentile 20' },
        { value: 'p30', label: 'Percentile 30' },
        { value: 'p40', label: 'Percentile 40' },
        { value: 'p50', label: 'Percentile 50' },
        { value: 'p60', label: 'Percentile 60' },
        { value: 'p70', label: 'Percentile 70' },
        { value: 'p80', label: 'Percentile 80' },
        { value: 'p90', label: 'Percentile 90' },

    ]
    // const frequencyOptions = [
    //     { value: 'Annual', label: 'Annual' },
    //     { value: 'Monthly', label: 'Monthly' },
    //     { value: 'Quarterly', label: 'Quarterly' },
    // ]

    // const frequencyOptions = frequencyList.sort((a,b) => a.localeCompare(b)).map(item => {
    //     return { value: item, label: item }
    // })
    const frequencyOptions = frequencyList?.map(item => {
        return { value: item, label: item }
    })
    const governmentOptions = [

        { value: 'label1', label: 'Label 1' },
        { value: 'label2', label: 'Label 2' },
    ]

    const availableYears = useMemo(() => (
        Array.from(new Set(
            xdata
                .map(item => parseInt(String(item).split('-')[0], 10))
                .filter(year => !Number.isNaN(year))
        )).sort((a, b) => a - b)
    ), [xdata])

    useEffect(() => {
        if (availableYears.length === 0) {
            setFromYear('')
            setToYear('')
            return
        }

        setFromYear(prev => prev && availableYears.includes(Number(prev)) ? prev : String(availableYears[0]))
        setToYear(prev => prev && availableYears.includes(Number(prev)) ? prev : String(availableYears[availableYears.length - 1]))
    }, [availableYears])

    const setPresetRange = (range) => {
        if (availableYears.length === 0) return
        setYearRange(range)

        const lastYear = availableYears[availableYears.length - 1]
        if (range === 'max') {
            setFromYear(String(availableYears[0]))
            setToYear(String(lastYear))
            return
        }

        const years = parseInt(range, 10)
        const firstAllowedYear = lastYear - years + 1
        const firstAvailableYear = availableYears.find(year => year >= firstAllowedYear) || availableYears[0]
        setFromYear(String(firstAvailableYear))
        setToYear(String(lastYear))
    }

    const changeFromYearHandler = (value) => {
        setYearRange('custom')
        setFromYear(value)
        if (toYear && Number(value) > Number(toYear)) setToYear(value)
    }

    const changeToYearHandler = (value) => {
        setYearRange('custom')
        setToYear(value)
        if (fromYear && Number(value) < Number(fromYear)) setFromYear(value)
    }

    const visibleIndexes = useMemo(() => {
        if (xdata.length === 0) return []
        const from = Number(fromYear)
        const to = Number(toYear)
        if (!from || !to) return xdata.map((_, index) => index)

        return xdata.reduce((acc, item, index) => {
            const year = parseInt(String(item).split('-')[0], 10)
            if (!Number.isNaN(year) && year >= from && year <= to) acc.push(index)
            return acc
        }, [])
    }, [fromYear, toYear, xdata])

    const displayX = useMemo(() => visibleIndexes.map(index => xdata[index]), [visibleIndexes, xdata])
    const displayY = useMemo(() => (
        ydata.map(item => ({
            ...item,
            data: visibleIndexes.map(index => item.data[index])
        }))
    ), [visibleIndexes, ydata])

    const displayTable = useMemo(() => (
        displayX.map((date, index) => {
            const row = { date }
            displayY.forEach(item => {
                row[item.name] = item.data[index]
            })
            return row
        })
    ), [displayX, displayY])

    const YEAR_RANGE_OPTIONS = [
        { value: '1', label: '1Y' },
        { value: '3', label: '3Y' },
        { value: '5', label: '5Y' },
        { value: '10', label: '10Y' },
        { value: 'max', label: 'Max' },
    ]



    const chartOptions = {
        chart: {
            id: 'basic-line-chart',
            toolbar: {
                show: true,
                tools: {
                    download: true,
                    selection: true,
                    zoom: true,
                    zoomin: true,
                    zoomout: true,
                    pan: true,
                    reset: true,
                }
            },
            fontFamily: 'Inter, sans-serif',
            animations: { enabled: true, speed: 400 },
        },
        stroke: {
            width: 2.5,
            curve: 'smooth'
        },
        colors: displayY.map(item => item.color),
        plotOptions: {
            bar: {
                columnWidth: '100%',
                barHeight: '100%',
                borderRadius: 1,


            },
            area: {
                fillTo: 'origin'
            },
            line: {
                isSloperChart: true,
            }
        },
        xaxis: {
            labels: {
                rotate: -45,
                rotateAlways: false,
                hideOverlappingLabels: true,
                style: {
                    fontSize: '10px',
                    fontFamily: 'IBM Plex Mono, monospace',
                    colors: '#737373',
                }
            },
            axisTicks: {
                show: true,
                color: '#d4d4d4',
            },
            axisBorder: { show: true, color: '#e5e5e5' },
            tickAmount: 10,
            // type: 'datetime',
            categories: displayX.map(item =>
                frequencyValue.value === "Annual"
                    ? item.split('-')[0]
                    : item.split('-')[0] + ' - ' + item.split('-')[1]
            ),
        },
        yaxis: {
            title: {
                text: unitValue.label,
                style: {
                    color: '#525252',
                    fontSize: '12px',
                    fontFamily: 'Inter, sans-serif',
                    fontWeight: 600
                }
            },
            labels: {
                style: {
                    fontSize: '10px',
                    fontFamily: 'IBM Plex Mono, monospace',
                    colors: '#737373',
                },
                formatter: function (value) {
                    return roundy(value)
                }
            }
        },
        fill: {
            opacity: 0.2,
            type: displayY.map(item => item.type == 'area' ? 'solid' : 'gradient'),
            gradient: {
                opacityFrom: 1,
                shadeIntensity: 0,
            }
        },
        grid:
        {
            show: true,
            borderColor: '#f0f0f0',
            strokeDashArray: 3,
            yaxis: { lines: { show: true } },
            xaxis: { lines: { show: false } },
        },
        legend: {
            show: legendValue,
            position: 'top',
            // horizontalAlign: 'left',
            horizontalAlign: 'left',
            fontSize: '11px',
            fontFamily: 'Inter, sans-serif',
            fontWeight: 500,
            // floating: true,
            markers: { size: 5, strokeWidth: 0 },
            itemMargin: { horizontal: 10 },
            labels: {
                colors: ['#1a1a1a']
            }
        },
        tooltip: {
            style: { fontFamily: 'IBM Plex Mono, monospace', fontSize: '11px' },
            y: {
                formatter: value => (value === null || value === undefined || isNaN(value)) ? 'N/A' : roundy(value, 2)
            }
        },
        dataLabels: { enabled: false },
        annotations: {
            yaxis: yAnnotationChart,
            xaxis: xAnnotationChart

            // xaxis: [
            //     {
            //         x: '2006 - 03',
            //         x2:'2008 - 03',
            //         strokeDashArray: 4,
            //         borderColor: '#B6B6B6',
            //         fillColor: '#B6B6B6',
            //         opacity: 0.2
            //     }
            // ],
        }
    };

    const series = (displayY.length > 0) ? displayY : [{ name: '', data: [] }]

    const menuHandler = (type) => {
        setMenuOption(type)
    }

    const folderInfo = useSelector(state => state.listFolder)
    const { loading: loadingFolder, error: errorFolder, folderList } = folderInfo

    const folderOptions = folderList?.map(item => ({
        value: item.id,
        label: item.folder_name,
    }))
    const addFolderHandler = () => {
        if (userInfo) {
            // dispatch(getFolders())
            dispatch({
                type: SAVE_SERIES_RESET,
            })
            let finalMeta = JSON.parse(JSON.stringify(metaSender))
            finalMeta.chart = {
                unit: unitValue,
                frequency: frequencyValue,
                transformation: transformationValue,
                country: countryValue,
                legend: legendValue,
                metrics: metricValue,
                xaxis: xAnnotationValue,
                yaxis: yAnnotationValue,
                highlight: highlightValue
            }
            setMetaSender(finalMeta)
            setAddFolderModal(true)
        } else {
            setLoginModal(true)
        }
    }
    const favoriteHandler = () => {
        console.log("asdg")
    }

    const updateHandler = () => {
        if (userInfo) {
            // dispatch(getFolders())
            let finalMeta = JSON.parse(JSON.stringify(metaSender))
            finalMeta.chart = {
                unit: unitValue,
                frequency: frequencyValue,
                transformation: transformationValue,
                country: countryValue,
                legend: legendValue,
                metrics: metricValue,
                xaxis: xAnnotationValue,
                yaxis: yAnnotationValue,
                highlight: highlightValue
            }
            setMetaSender(finalMeta)
            // let Id = folderList?.filter(item => item.folder_name = 'Main Folder')[0].id
            const Id = isSaved.id
            dispatch(updateSeries(Id, finalMeta, nameValue))
        } else {
            setLoginModal(true)
        }
    }

    const updateInfo = useSelector(state => state.updateSeries)
    const { loading: loadingUpdate, error: errorUpdate, success } = updateInfo


    const shareHandler = () => {
        console.log("shareHandler")
    }
    const closeHandler = () => {
        closeCallback()
    }

    const closeFolderModal = () => {
        setAddFolderModal(false)
    }
    const closeLabelModal = () => {
        setAddLabelModal(false)
    }



    const changeUnitHandler = (option) => {
        setUnitValue(option)
    }

    const addCountryHandler = () => {
        if (countryValue.length > 0) {
            setCountryValue(prevCountries => [...prevCountries, { id: prevCountries[prevCountries.length - 1].id + 1, value: '', label: '', color: defaultColors[(prevCountries[prevCountries.length - 1].id + 1) % defaultColors.length], type: 'line', countryType: '' }])
        } else {
            setCountryValue(prevCountries => [...prevCountries, { id: 0, value: '', label: '', color: defaultColors[0], type: 'line', countryType: '' }])
        }
    }
    const addXannotationHandler = () => {
        if (xAnnotationValue.length > 0) {
            setXannotationValue(prevAnnotation => [...prevAnnotation, { id: prevAnnotation[prevAnnotation.length - 1].id + 1, value: '', label: '' }])
        }
        else {
            setXannotationValue(prevAnnotation => [...prevAnnotation, { id: 0, value: '', label: '' }])
        }
    }
    const addYannotationHandler = () => {
        if (yAnnotationValue.length > 0) {
            setYannotationValue(prevAnnotation => [...prevAnnotation, { id: prevAnnotation[prevAnnotation.length - 1].id + 1, value: '', label: '' }])
        } else {
            setYannotationValue(prevAnnotation => [...prevAnnotation, { id: 0, value: '', label: '' }])
        }
    }
    const addHighlightHandler = () => {
        if (highlightValue.length > 0) {
            setHighlightValue(prevHighlight => [...prevHighlight, { id: prevHighlight[prevHighlight.length - 1].id + 1, x1: { value: '', label: '' }, x2: { value: '', label: '' } }])
        } else {
            setHighlightValue(prevHighlight => [...prevHighlight, { id: 0, x1: { value: '', label: '' }, x2: { value: '', label: '' } }])
        }
    }
    const addMetricHandler = () => {
        if (metricValue.length > 0) {
            setMetricValue(prevMetric => [...prevMetric, { id: prevMetric[prevMetric.length - 1].id + 1, value: '', label: '' }])
        } else {
            setMetricValue(prevMetric => [...prevMetric, { id: 0, value: '', label: '' }])
        }
    }

    const closeChartModal = () => {
        setChartModal(false)
    }

    useEffect(() => {
        if (countryValue.length > 0 && specificData) {
            let x = []
            const tempCountry = countryValue.filter(item => item.value != '')
            // console.log("TEMPCOUNTRY: ", tempCountry)

            // Obtener el valor de transformación actual (puede ser '' para "No transformation")
            const currentTransformation = transformationValue?.value || ''

            // Console.log para mostrar todos los datos cuando cambie el país seleccionado
            // console.log("=== DATOS DEL VIEWER MODAL ===");
            // console.log("Países seleccionados:", tempCountry);
            // console.log("Datos completos:", specificData);
            // console.log("Frecuencia seleccionada:", frequencyValue);
            // console.log("Unidad seleccionada:", unitValue);
            // console.log("Transformación seleccionada:", currentTransformation);

            // Función para verificar si la transformación coincide
            const matchesTransformation = (recordTrans) => {
                const recordTransValue = recordTrans ? String(recordTrans).trim() : ''
                return recordTransValue === currentTransformation
            }

            tempCountry.forEach(item => {
                let xtemp = []

                if (item.countryType == 'country') {
                    if (!specificData.Countries[item.value]?.data) {
                        // console.log(`No hay datos para el país: ${item.value}`);
                        return
                    }
                    const countryData = specificData.Countries[item.value]?.data?.filter(element => 
                        element.frequency == frequencyValue.value && 
                        element.unit == unitValue.value &&
                        matchesTransformation(element.transformation)
                    );
                    // console.log(`Datos filtrados para ${item.value}:`, countryData);
                    xtemp = countryData.map(element => element.date)
                }
                else if (item.countryType == 'region') {
                    if (!specificData.Regions[item.value]?.data) {
                        // console.log(`No hay datos para la región: ${item.value}`);
                        return
                    }
                    const regionData = specificData.Regions[item.value]?.data?.filter(element => 
                        element.frequency == frequencyValue.value && 
                        element.unit == unitValue.value &&
                        matchesTransformation(element.transformation)
                    );
                    // console.log(`Datos filtrados para la región ${item.value}:`, regionData);
                    xtemp = regionData.map(element => element.date)
                    // xtemp = regionData.map(element => element.date.split("T")[0])
                }
                // console.log('xtemp: ', xtemp)
                // if(xtemp){
                x = [...x, ...xtemp]
                // }
            })
            x = [...new Set(x)].sort()
            // console.log("Fechas (X data):", x);

            setXdata(x)

            let y = tempCountry.filter(item =>
                (item.countryType == 'country' && specificData.Countries[item.value]?.data != undefined) ||
                (item.countryType == 'region' && specificData.Regions[item.value]?.data != undefined)).map(item => {
                    return {
                        name: item.label,
                        data: x.map(e => {
                            let entry;
                            if (item.countryType == 'region') {
                                entry = specificData.Regions[item.label].data
                                    ?.filter(a => a.frequency == frequencyValue.value && a.unit == unitValue.value && matchesTransformation(a.transformation))
                                    // .find(b => b.date == `${e}T00:00:00.000`);
                                    .find(b => b.date == e);
                            } else {
                                entry = specificData.Countries[item.label].data
                                    ?.filter(a => a.frequency == frequencyValue.value && a.unit == unitValue.value && matchesTransformation(a.transformation))
                                    .find(b => b.date == e);
                            }

                            if (!entry) return null;

                            const num = parseFloat(entry.value);
                            return isNaN(num) ? null : num;
                        }),
                        type: item.type,
                        color: item.color,
                    }
                });

            // console.log("Datos Y (series del gráfico):", y);
            setYdata(y);

            let sourceSet = new Set()
            let source = tempCountry.map(item => {
                if (item.countryType == 'region') {
                    setSourceValue('Multiple sources')
                    return
                } else {
                    let tempArray = specificData.Countries[item.label]?.sources[unitValue.label]

                    if (!tempArray) {
                        return
                    }
                    if (tempArray) {
                        tempArray.forEach(src => {
                            sourceSet.add(src)
                        })
                    }
                }
            })
            let sourceList = Array.from(sourceSet)
            // console.log("sourceList: ", sourceList)
            let sourceString = sourceList.join(', ')
            // console.log("sourceString: ", sourceString)
            setSourceValue(sourceString)


            let xanntemp = xAnnotationValue.map(item => {
                return {
                    // x: item.value.split('-')[0],
                    x: (frequencyValue.value == 'Annual') ? item.value.split('-')[0] : item.value.split('-')[0] + ' - ' + item.value.split('-')[1],
                    // x2: '2022 - 01',

                    strokeDashArray: 4,
                    borderColor: '#B6B6B6',
                    fillColor: '#B6B6B6',
                    opacity: 1
                }
            })

            let highlighttemp = highlightValue.map(item => {
                return {
                    x: (frequencyValue.value == 'Annual') ? item.x1.value.split('-')[0] : item.x1.value.split('-')[0] + ' - ' + item.x1.value.split('-')[1],
                    x2: (frequencyValue.value == 'Annual') ? item.x2.value.split('-')[0] : item.x2.value.split('-')[0] + ' - ' + item.x2.value.split('-')[1],
                    // x2: '2022 - 01',

                    strokeDashArray: 4,
                    borderColor: '#B6B6B6',
                    fillColor: '#B6B6B6',
                    opacity: 0.5
                }
            })

            let d = [...xanntemp, ...highlighttemp]
            setXannotationChart(d)

            let yanntemp = yAnnotationValue.map(item => {
                return {
                    y: item.value,
                    // x2: '2022 - 01',

                    strokeDashArray: 4,
                    borderColor: '#B6B6B6',
                    fillColor: '#B6B6B6',
                    opacity: 1,
                    label: {
                        text: item.text,
                        position: 'left',
                        offsetX: 25,
                        style: {
                            background: '#2aac9c',
                            color: '#ffffff',
                            fontFamily: 'Open Sans',
                        }
                    }
                }
            })

            let metrictemp = metricValue.filter(item => item.value != '').map(item => {

                let met = 0
                countryValue.filter(e => e.value != '').forEach(country => {
                    if (country.countryType == 'country') {
                        let gg = specificData.Countries[country.value]?.statistics?.[`${frequencyValue.value}_${unitValue.value}`]?.[item.value]
                        met += parseFloat(gg)
                    }
                    else if (country.countryType == 'region') {
                        let gg = specificData.Regions[country.value]?.statistics?.[`${frequencyValue.value}_${unitValue.value}`]?.[item.value]
                        met += parseFloat(gg)
                    }
                })
                // console.log('met', met)

                let metricY = null
                if (met) {
                    metricY = met / countryValue.filter(e => e.value != '').length
                }

                if (metricY) {

                    return {
                        y: metricY,
                        strokeDashArray: 1,
                        borderColor: '#333333',
                        fillColor: '#333333',
                        opacity: 1,
                        label: {
                            text: item.label,
                            style: {
                                background: '#577bab',
                                color: '#ffffff',
                                fontFamily: 'Open Sans',
                                // padding: {
                                //     top: 2,
                                //     bottom: 5,
                                // }
                            }
                        }
                    }
                }
            })

            let yfinal = [...yanntemp, ...metrictemp]

            setYannotationChart(yfinal)

            let u = []
            for (let i = 0; i < x.length; i++) {
                let temp = {}
                temp.date = x[i]
                y.forEach(e => {
                    temp[e.name] = e.data[i]
                })
                u.push(temp)
            }
            setTable(u)
        }
    }, [countryValue, frequencyValue, unitValue, transformationValue, xAnnotationValue, yAnnotationValue, highlightValue, metricValue, specificData])

    const tempInfo = useSelector(state => state.getCountryData)
    const { loading: loadingTemp, error: errorTemp, data: tempData } = tempInfo

    const changeCountryHandler = async (option, id) => {
        // console.log("id: ", id)
        // console.log("value: ", option.value)
        // console.log("label: ", option.label)
        if (option.value) {
            const indicator = meta.indicator
            const country = option.value

            if (regionList.find(item => item == country)) {
                var rList = Object.keys(specificData.Regions)
                var validationIndex = rList.findIndex(item => item == country)
                // console.log("Rlist: ", cList)
                // console.log("validationIndex: ", validationIndex)

                if (validationIndex == -1) {
                    dispatch(getCountryData(indicator, country))
                }
            } else {

                var cList = Object.keys(specificData.Countries)
                var validationIndex = cList.findIndex(item => item == country)
                // console.log("Clist: ", cList)
                // console.log("validationIndex: ", validationIndex)

                if (validationIndex == -1) {
                    dispatch(getCountryData(indicator, country))
                }
            }

        }

        setCountryValue(prevCountries =>
            prevCountries.map(item => item.id == id ? { ...item, value: option.value, label: option.label, countryType: option.type } : item)

        )
    }

    useEffect(() => {
        // console.log("tempData changed")
        if (tempData) {
            const _data = tempData?.data_dict?.data
            if (!_data) return
            if (_data.Regions && Object.keys(_data.Regions).length > 0) {
                const nameRegion = Object.keys(_data.Regions)[0]
                const rData = _data.Regions[nameRegion]
                setSpecificData(prev => ({
                    ...prev, Regions: {
                        ...prev.Regions,
                        [nameRegion]: rData

                    }
                }))
            }
            var countryLabels = _data.Countries ? Object.keys(_data.Countries) : []
            if (countryLabels.length > 0) {
                for (var i = 0; i < countryLabels.length; i++) {
                    const nameCountry = countryLabels[i]
                    const cData = _data.Countries[nameCountry]
                    setSpecificData(prev => ({
                        ...prev, Countries: {
                            ...prev.Countries,
                            [nameCountry]: cData

                        }
                    }))
                }

            }

            // Desactivar el loading automático cuando se completen los datos
            if (autoLoadingFirstCountry) {
                setAutoLoadingFirstCountry(false)
            }
        }

    }, [tempData, autoLoadingFirstCountry])



    const changeXannotationsHandler = (option, id) => {
        setXannotationValue(prevAnnotation =>
            prevAnnotation.map(item => item.id == id ? { ...item, value: option.value, label: option.label } : item)
        )
    }
    const changeYannotationsHandler = (option, id) => {
        setYannotationValue(prevAnnotation =>
            prevAnnotation.map(item => item.id == id ? { ...item, value: option, label: option } : item)
        )
    }
    const changeMetricHandler = (option, id) => {
        setMetricValue(prevMetric =>
            prevMetric.map(item => item.id == id ? { ...item, value: option.value, label: option.label } : item)
        )
    }
    const changeHighlightHandler = (option, id, xn) => {
        if (xn == 'x1') {
            setHighlightValue(prevHighlight =>
                prevHighlight.map(item => item.id == id ? { ...item, x1: { value: option.value, label: option.label } } : item)
            )
        }
        if (xn == 'x2') {
            setHighlightValue(prevHighlight =>
                prevHighlight.map(item => item.id == id ? { ...item, x2: { value: option.value, label: option.label } } : item)
            )
        }
    }
    const changeColorHandler = (color, id) => {
        setCountryValue(prevCountries =>
            prevCountries.map(item => item.id == id ? { ...item, color: color } : item)
        )
    }
    const changeChartTypeHandler = (type, id) => {
        setCountryValue(prevCountries =>
            prevCountries.map(item => item.id == id ? { ...item, type: type } : item)
        )
        setChartModal(false)
    }
    const deleteCountryHandler = (id) => {
        let updatedItems = countryValue.filter(item => item.id != id)
        updatedItems = updatedItems.map((item, index) => ({ ...item, id: index }))
        // updatedItems.map(item => (item.id > id) ? ({...item, id: item.id - 1}) : item)
        setCountryValue(updatedItems)
    }
    const deleteXannotationHandler = (id) => {
        let updatedItems = xAnnotationValue.filter(item => item.id != id)
        updatedItems = updatedItems.map((item, index) => ({ ...item, id: index }))
        // updatedItems.map(item => (item.id > id) ? ({...item, id: item.id - 1}) : item)
        setXannotationValue(updatedItems)
    }
    const deleteYannotationHandler = (id) => {
        let updatedItems = yAnnotationValue.filter(item => item.id != id)
        updatedItems = updatedItems.map((item, index) => ({ ...item, id: index }))
        // updatedItems.map(item => (item.id > id) ? ({...item, id: item.id - 1}) : item)
        setYannotationValue(updatedItems)
    }
    const deleteHighlightHandler = (id) => {
        let updatedItems = highlightValue.filter(item => item.id != id)
        updatedItems = updatedItems.map((item, index) => ({ ...item, id: index }))
        // updatedItems.map(item => (item.id > id) ? ({...item, id: item.id - 1}) : item)
        setHighlightValue(updatedItems)
    }
    const deleteMetricHandler = (id) => {
        let updatedItems = metricValue.filter(item => item.id != id)
        updatedItems = updatedItems.map((item, index) => ({ ...item, id: index }))
        // updatedItems.map(item => (item.id > id) ? ({...item, id: item.id - 1}) : item)
        setMetricValue(updatedItems)
    }



    const exportHandler = (type) => {
        let finalData = []
        for (let i = 0; i < displayX.length; i++) {
            let object = {}
            object.date = displayX[i]
            displayY.forEach(item => {
                object[item.name] = item.data[i]
            })
            finalData.push(object)
        }

        const worksheet = XLSX.utils.json_to_sheet(finalData);

        // Crea un libro de trabajo (workbook) y agrega la hoja de trabajo
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        if (type == 'excel') {
            XLSX.writeFile(workbook, `${meta.indicator}.xlsx`);
        } else if (type == 'csv') {
            XLSX.writeFile(workbook, `${meta.indicator}.csv`, { bookType: 'csv' });
        }
        // Genera un archivo Excel y lo descarga
    }

    const openLabelModal = (id) => {
        setLabelId(id)
        setAddLabelModal(true)
    }

    const addLabelHandler = (id, value) => {

        setYannotationValue(prevAnnotations =>
            prevAnnotations.map(item => item.id == id ? { ...item, text: value } : item)
        )
    }

    return (
        <div className='viewer-container'>
            <Row className='m-0 h-100 overflow-hidden'>
                <Col md={3} style={{ borderRight: '1px solid #DDDDDD', height: '100%', overflowY: 'auto' }} className='p-0 overflow-auto'>
                    <div style={{ background: '#F2F2F2' }}>
                        <div className='d-flex justify-content-between align-items-center'>
                            {userInfo && isSaved && (
                                <p className='viewer-breadcrumb m-0 px-4'>
                                    <i style={{ color: '#787878' }} className="fa-solid fa-chevron-right pe-2 pt-4"></i>
                                    {isSaved.folder_name}
                                </p>
                            )}
                            {/* <i className="fa-solid fa-floppy-disk pt-4 pe-4"></i> */}
                        </div>
                        <div className='viewer-menu-header'>
                            <div onClick={e => menuHandler('settings')}>
                                <i className={`fa-solid fa-sliders ${menuOption == 'settings' && 'viewer-active'}`}></i>
                                <p className={`${menuOption == 'settings' && 'viewer-active'}`}>Settings</p>
                            </div>
                            <div onClick={e => menuHandler('lines')}>
                                <i className={`fa-solid fa-arrow-trend-up ${menuOption == 'lines' && 'viewer-active'}`}></i>
                                <p className={`${menuOption == 'lines' && 'viewer-active'}`}>Lines</p>
                            </div>
                        </div>
                    </div>

                    {(loadingCountries || loadingTemp || autoLoadingFirstCountry) ? (
                        <div className='feester'>
                            <Spinner animation="border" />
                            <p className='mt-3' style={{fontSize: '14px', color: '#666'}}>
                                {loadingCountries ? 'Loading countries...' : 'Loading country data...'}
                            </p>
                        </div>
                    ) : errorTemp ? (
                        <Message variant={'danger'}>{error}</Message>
                    ) : errorCountries ? (
                        <Message variant={'danger'}>{errorCountries}</Message>
                    ) : menuOption == 'settings' ? (
                        <div className='px-4 pt-5'>

                            {userInfo && (
                                <div className='pb-2'>
                                    <p className='custom-select-label'>Serie Name:</p>

                                    <div className='d-flex align-items-center pb-2'>
                                        <input disabled={nameDisabled} value={nameValue} onChange={e => setNameValue(e.target.value)} className='viewer-input' placeholder='Series name' type="text" />
                                        <i onClick={e => setNameDisabled(!nameDisabled)} style={{ cursor: 'pointer', color: '#D9D9D9' }} className="fa-solid fa-pen ps-2 pe-1"></i>
                                    </div>
                                </div>
                            )}

                            <div className='pb-2'>
                                <p className='custom-select-label'>Select Unit:</p>
                                <Select
                                    className="custom-select-container"
                                    classNamePrefix="custom-select"
                                    placeholder={'Select unit'}
                                    value={unitValue}
                                    options={unitOptions}
                                    onChange={option => changeUnitHandler(option)}
                                />
                            </div>

                            <div className='pb-2'>
                                <p className='custom-select-label'>Select Transformation:</p>
                                <Select
                                    className="custom-select-container"
                                    classNamePrefix="custom-select"
                                    placeholder={'Select transformation'}
                                    value={transformationValue}
                                    options={transformationOptions}
                                    onChange={option => setTransformationValue(option)}
                                    isDisabled={transformationOptions.length === 0}
                                />
                            </div>

                            {/* <div className='pb-2'>
                            <p className='custom-select-label'>Select Government Level:</p>
                            <Select
                                className="custom-select-container"
                                classNamePrefix="custom-select"
                                isMulti={true}
                                placeholder={'Select unit'}
                                value={government}
                                options={governmentOptions}
                                onChange={option => setGovernment(option)}
                                />
                        </div> */}

                            <div className='pb-2'>
                                <p className='custom-select-label'>Select Frequency:</p>
                                <Select
                                    className="custom-select-container"
                                    classNamePrefix="custom-select"
                                    placeholder={'Select frequency'}
                                    value={frequencyValue}
                                    options={frequencyOptions}
                                    onChange={option => setFrequencyValue(option)}
                                />
                            </div>

                            <div className='pb-2'>
                                <p className='custom-select-label'>Select Country/Region:</p>
                                {countryValue.map((item, index) => (
                                    <div key={index} className='d-flex align-items-center pb-2'>
                                        <Select
                                            className="custom-select-container"
                                            classNamePrefix="custom-select"
                                            options={countryOptions}
                                            value={item}
                                            placeholder={'Select country'}
                                            isDisabled={autoLoadingFirstCountry || loadingCountries || loadingTemp}
                                            isLoading={(autoLoadingFirstCountry || loadingTemp) && index === 0}
                                            onChange={option => changeCountryHandler(option, item.id)}
                                        />
                                        <i onClick={(e) => deleteCountryHandler(item.id)} style={{ cursor: (autoLoadingFirstCountry || loadingTemp) ? 'not-allowed' : 'pointer', opacity: (autoLoadingFirstCountry || loadingTemp) ? 0.5 : 1 }} className="fa-regular fa-trash-can ps-2 pe-1"></i>
                                        <Form.Control
                                            type="color"
                                            className='custom-color-picker  me-1'
                                            id="exampleColorInput"
                                            // defaultValue={(item.color) ? item.color: defaultColors[index]}
                                            value={item.color}
                                            title="Choose your color"
                                            disabled={autoLoadingFirstCountry || loadingTemp}
                                            onChange={color => changeColorHandler(color.target.value, item.id)}
                                        />
                                        <i onClick={e => { setChartType(item.type); setChartId(item.id); setChartModal(true) }} style={{ color: (autoLoadingFirstCountry || loadingTemp) ? '#ccc' : '#818181', cursor: (autoLoadingFirstCountry || loadingTemp) ? 'not-allowed' : 'pointer' }} className={`fa-solid fa-chart-${item.type}`}></i>
                                    </div>
                                ))}

                            </div>

                            <div onClick={addCountryHandler} className='viewer-action' style={{ opacity: (autoLoadingFirstCountry || loadingCountries) ? 0.5 : 1, pointerEvents: (autoLoadingFirstCountry || loadingCountries) ? 'none' : 'auto' }}>
                                <i className="fa-regular fa-square-plus"></i> Add country-region
                            </div>

                            <div className='py-5'>
                                <Form>
                                    <Form.Check // prettier-ignore
                                        type="switch"
                                        id="custom-switch"
                                        label="Show legends"
                                        className='viewer-switch'
                                        checked={legendValue}
                                        onChange={option => setLegendValue(option.target.checked)}
                                    />

                                </Form>
                            </div>
                            {userInfo && isSaved && (
                                <div className='d-flex  justify-content-center mb-5'>
                                    {loadingUpdate ? (
                                        <Spinner animation="border" as={'span'} style={{ width: '20px', height: '20px' }} />
                                    ) : error ? (
                                        <>
                                            <Message variant={'danger'}>{error}</Message>
                                            <div onClick={updateHandler} className='button-dark-empty w-100'>
                                                Apply Changes
                                            </div>
                                        </>
                                    ) : (
                                        <div className='w-100'>
                                            <div onClick={updateHandler} className='button-dark-empty w-100 mb-2'>
                                                Apply Changes
                                            </div>
                                            {success && (
                                                <Message variant={'success'}>Changes applied succesfully</Message>
                                            )}
                                        </div>
                                    )}

                                </div>
                            )}



                        </div>
                    ) : (
                        <div className='px-4 pt-5'>
                            <div className='pb-2'>
                                <p className='custom-select-label'>Add Metric:</p>

                                {metricValue.map((item, index) => (
                                    <div key={index} className='d-flex align-items-center pb-2'>
                                        <Select
                                            className="custom-select-container"
                                            classNamePrefix="custom-select"
                                            options={metricOptions}
                                            value={item}
                                            placeholder={'Select metric'}
                                            onChange={option => changeMetricHandler(option, item.id)}
                                        />
                                        <i onClick={(e) => deleteMetricHandler(item.id)} style={{ cursor: 'pointer', color: '#D9D9D9' }} className="fa-regular fa-trash-can ps-2 pe-1"></i>
                                    </div>
                                ))}

                                <div onClick={addMetricHandler} className='viewer-action'>
                                    <i className="fa-regular fa-square-plus"></i> Add other metric
                                </div>

                            </div>

                            <div className='pb-2'>
                                <p className='custom-select-label'>x-axis Annotations:</p>

                                {xAnnotationValue.map((item, index) => (
                                    <div key={index} className='d-flex align-items-center pb-2'>
                                        <Select
                                            className="custom-select-container"
                                            classNamePrefix="custom-select"
                                            options={xAnnotationsOptions}
                                            value={item}
                                            placeholder={'Select annotation'}
                                            onChange={option => changeXannotationsHandler(option, item.id)}
                                        />
                                        <i onClick={(e) => deleteXannotationHandler(item.id)} style={{ cursor: 'pointer', color: '#D9D9D9' }} className="fa-regular fa-trash-can ps-2 pe-1"></i>
                                    </div>
                                ))}

                                <div onClick={addXannotationHandler} className='viewer-action'>
                                    <i className="fa-regular fa-square-plus"></i> Add other x-axis annotation
                                </div>
                            </div>

                            <div className='pb-2'>
                                <p className='custom-select-label'>y-axis Annotations:</p>

                                {yAnnotationValue.map((item, index) => (
                                    <>
                                        <div key={index} className='d-flex align-items-center'>
                                            <input value={item.value} onChange={option => changeYannotationsHandler(option.target.value, item.id)} className='viewer-input' type="number" />
                                            <i onClick={(e) => openLabelModal(item.id)} style={{ cursor: 'pointer', color: '#D9D9D9' }} className="fa-solid fa-font ps-2"></i>
                                            <i onClick={(e) => deleteYannotationHandler(item.id)} style={{ cursor: 'pointer', color: '#D9D9D9' }} className="fa-regular fa-trash-can ps-1 pe-1"></i>
                                        </div>
                                        <p className='viewer-label-annotation pb-2'>Label: {item.text}</p>
                                    </>
                                ))}

                                <div onClick={addYannotationHandler} className='viewer-action'>
                                    <i className="fa-regular fa-square-plus"></i> Add other y-axis annotation
                                </div>
                            </div>

                            <div className='pb-5'>
                                <p className='custom-select-label'>Highlight Sections:</p>
                                {highlightValue.map((item, index) => (

                                    <div className='d-flex align-items-center py-2 border-bottom'>
                                        <div style={{ flex: '1' }}>
                                            <Select
                                                className="custom-select-container pb-2"
                                                classNamePrefix="custom-select"
                                                placeholder={'Select highlight'}
                                                value={item.x1}
                                                options={xAnnotationsOptions}
                                                onChange={option => changeHighlightHandler(option, item.id, 'x1')}
                                            />
                                            <Select
                                                className="custom-select-container"
                                                classNamePrefix="custom-select"
                                                placeholder={'Select highlight'}
                                                value={item.x2}
                                                options={xAnnotationsOptions}
                                                onChange={option => changeHighlightHandler(option, item.id, 'x2')}
                                            />
                                        </div>
                                        <div>
                                            <i onClick={(e) => deleteHighlightHandler(item.id)} style={{ cursor: 'pointer', color: '#D9D9D9' }} className="fa-regular fa-trash-can ps-2 pe-1"></i>
                                        </div>
                                    </div>

                                ))}



                                <div onClick={addHighlightHandler} className='viewer-action pt-1'>
                                    <i className="fa-regular fa-square-plus"></i> Add other highlighted section
                                </div>
                            </div>


                            {userInfo && isSaved && (
                                <div className='d-flex  justify-content-center mb-5'>
                                    {loadingUpdate ? (
                                        <Spinner animation="border" as={'span'} style={{ width: '20px', height: '20px' }} />
                                    ) : error ? (
                                        <>
                                            <Message variant={'danger'}>{error}</Message>
                                            <div onClick={updateHandler} className='button-dark-empty w-100'>
                                                Apply Changes
                                            </div>
                                        </>
                                    ) : (
                                        <div className='w-100'>
                                            <div onClick={updateHandler} className='button-dark-empty w-100 mb-2'>
                                                Apply Changes
                                            </div>
                                            {success && (
                                                <Message variant={'success'}>Changes applied succesfully</Message>
                                            )}
                                        </div>
                                    )}
                                </div>
                            )}


                        </div>
                    )}
                </Col>
                <Col md={9} style={{ height: '100%', overflowY: 'auto' }} className='p-0'>
                    <div className='viewer-header-container'>
                        <div>
                            <div className='viewer-header-icons'>
                                <i onClick={e => addFolderHandler()} className="fa-solid fa-folder-plus"></i>
                                {/* {!isSaved && (
                            <i onClick={e => favoriteHandler()} className="fa-solid fa-star"></i>
                        )} */}
                                {/* <i onClick={e => shareHandler()} className="fa-solid fa-share"></i> */}
                            </div>
                        </div>
                        <div style={{ flex: '1' }} className='text-center mt-3'>
                            <div className='d-flex justify-content-center align-items-center'>
                                <h1 style={{ fontSize: '40px' }} className='search-title'>{meta.indicator}</h1>
                                {userInfo && isSaved && (
                                    <OverlayTrigger
                                        placement={'right'}
                                        overlay={
                                            <Tooltip>
                                                Serie saved in <strong className='text-white'>{isSaved.folder_name}</strong>
                                            </Tooltip>
                                        }
                                    >
                                        <img src="/static/icons/disk.svg" className='ps-3' style={{ height: '25px', width: 'auto' }} alt="" />
                                    </OverlayTrigger>
                                )}
                            </div>
                            <p style={{ color: '#6A6A6A' }} className='comment fw-normal'>{definitionValue}</p>
                        </div>
                        <i onClick={e => closeHandler()} style={{ color: '#676767', fontSize: '24px', cursor: 'pointer' }} className="fa-solid fa-xmark"></i>
                    </div>
                    <div style={{ backgroundColor: 'rgba(250, 250, 250, 0.9)' }} className='px-5 py-2'>
                        <div className='viewer-timeframe-toolbar'>
                            <div className='viewer-timeframe-presets' aria-label='Chart timeframe presets'>
                                {YEAR_RANGE_OPTIONS.map(option => (
                                    <button
                                        key={option.value}
                                        type='button'
                                        className={`viewer-timeframe-btn${yearRange === option.value ? ' active' : ''}`}
                                        onClick={() => setPresetRange(option.value)}
                                        disabled={availableYears.length === 0}
                                    >
                                        {option.label}
                                    </button>
                                ))}
                            </div>
                            <div className='viewer-year-range'>
                                <label>
                                    <span>From</span>
                                    <select
                                        value={fromYear}
                                        onChange={event => changeFromYearHandler(event.target.value)}
                                        disabled={availableYears.length === 0}
                                    >
                                        {availableYears.map(year => (
                                            <option key={year} value={year}>{year}</option>
                                        ))}
                                    </select>
                                </label>
                                <label>
                                    <span>To</span>
                                    <select
                                        value={toYear}
                                        onChange={event => changeToYearHandler(event.target.value)}
                                        disabled={availableYears.length === 0}
                                    >
                                        {availableYears.map(year => (
                                            <option key={year} value={year}>{year}</option>
                                        ))}
                                    </select>
                                </label>
                            </div>
                            <div className='viewer-timeframe-summary'>
                                {displayX.length > 0 ? `${displayX.length} periods` : 'No periods'}
                            </div>
                        </div>
                        <Chart options={chartOptions} series={series} height={'500px'} type="line" />
                        <p className='source'><b>Source:</b> {sourceValue}</p>
                    </div>
                    <div className='viewer-table-container'>
                        <div className='d-flex justify-content-end pb-3'>
                            <i onClick={e => exportHandler('excel')} style={{ color: '#797979', cursor: 'pointer' }} className="fa-solid fa-file-excel px-2"></i>
                            <i onClick={e => exportHandler('csv')} style={{ color: '#797979', cursor: 'pointer' }} className="fa-solid fa-file-csv"></i>
                            {/* <i onClick={e => exportHandler('excel')} style={{color: '#2e7d32', cursor: 'pointer'}} className="fa-solid fa-file-excel px-2"></i>
                    <i onClick={e => exportHandler('csv')} style={{color: '#2e7d32', cursor: 'pointer'}} className="fa-solid fa-file-csv"></i> */}
                        </div>
                        <table className='viewer-table'>
                            <thead>
                                <tr>
                                    {displayTable.length > 0 && Object.keys(displayTable[0]).map((item, index) => (
                                        <th key={index}>{item}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {displayTable.map((item, index) => (
                                    <tr key={index}>
                                        {Object.keys(item).map(key => (
                                            <td key={key} style={{ background: (key == 'date') ? '#EBEDF1' : '#ffffff' }}>
                                                {(key != 'date' && roundy(parseFloat(item[key]))) ? (
                                                    roundy(parseFloat(item[key]))
                                                ) : key != 'date' ? (
                                                    ''
                                                ) : (
                                                    `${item[key].split('-')[0]} - ${item[key].split('-')[1]}`
                                                )}
                                            </td>
                                        ))}
                                    </tr>
                                ))}


                            </tbody>
                        </table>
                    </div>
                </Col>
            </Row>

            {chartModal && (
                <ChartTypeModal
                    closeCallback={closeChartModal}
                    chartCallback={changeChartTypeHandler}
                    type={chartType}
                    id={chartId}
                />
            )}

            {addFolderModal && (
                // <AddFolderModal closeCallback={closeFolderModal} meta={metaSender} folders={folderOptions} />
                <AddFolderModal closeCallback={closeFolderModal} meta={metaSender} folders={folderOptions} name={nameValue} />
            )}
            {addLabelModal && (
                // <AddFolderModal closeCallback={closeFolderModal} meta={metaSender} folders={folderOptions} />
                <AddLabelModal closeCallback={closeLabelModal} addCallback={addLabelHandler} id={labelId} />
            )}

            {loginModal && (
                <LoginModal
                    closeCallback={() => { setLoginModal(false) }}
                    registerCallback={e => { setLoginModal(false); setRegisterModal(true) }}
                    forgotCallback={e => { setLoginModal(false); setForgotModal(true) }}
                    isViewer={true} />
            )}

            {registerModal && (
                <RegisterModal closeCallback={() => { setRegisterModal(false) }} loginCallback={e => { setRegisterModal(false); setLoginModal(true) }} />
            )}


            {forgotModal && (
                <ForgotModal closeCallback={() => { setForgotModal(false) }} />
            )}
        </div>
    )
}

export default ViewerModal
